<script>
import { Link, useNavigate, useLocation } from "svelte-navigator";
import { user } from "./store";
import { login, HttpError } from './services';
import { SignInHeader, SignInDesc } from './theme';

const navigate = useNavigate();
const location = useLocation();

let email = '';
let password = '';
let showJustChangedPassword;

$: {
  const params = new URLSearchParams($location.search);
  showJustChangedPassword = params.get('changed') === '1';
}

let error;
let loading = false;

async function handleSubmit(e) {
  event.preventDefault()

  showJustChangedPassword = false;
  error = undefined;

  if (email.length === 0 || password.length === 0) {
    error = 'Please enter your email and password';
    return;
  }

  loading = true;

  try {
    const {id, token, firstname, lastname} = await login(email, password);

    $user = { id, email, firstname, lastname, name: `${firstname} ${lastname}` };
    navigate('/', { replace: true });
  } catch (e) {
    if (e instanceof HttpError && e.status === 403) {
      error = "Incorrect email or password";
    } else {
      console.error(e);
      error = e.message;
    }
  } finally {
    loading = false;
  }
}
</script>

<div class="login-title">
  {SignInHeader}
</div>

<div class="login-subtitle">
  {SignInDesc}
</div>

{#if showJustChangedPassword}
  <div class="success-box mb-16">Your password has been changed. Please login.</div>
{/if}

<form on:submit={handleSubmit}>
  {#if error}
    <div class="error-box mb-16">{error}</div>
  {/if}

  <div class="col mb-16">
    <div class="form-label">Email</div>
    <input bind:value={email} type="email" name="email" placeholder="Email" />
  </div>
  
  <div class="col mb-16">
    <div class="form-label">Password</div>
    <input bind:value={password} type="password" name="password" placeholder="Password" />
  </div>

  <div class="row vcenter between" style="margin-top: 48px">
    <Link to="/forgot" class="login-help-link">Forgot your password?</Link>
    <button type="submit" class="button" disabled={loading}>Login</button>
  </div>
</form>